import { ResponseWithData } from '@utils/ajax';
import { get, StandardResponse } from '.';

export type DiscordUserResponse = {
  userId: string;
  discordUserId: string;
  discordNickname: string;
  discordUsername: string;
  discordServerName?: string;
  userRole: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
};

export type DiscordRoleResponse = {
  id: string;
  name: string;
};

export enum DiscordStatus {
  LINKED = 'linked',
  UNLINKED = 'unlinked',
  KICKED = 'kicked',
  BANNED = 'banned'
}

export async function getDiscordUser({
  userId
}: {
  userId: string;
}): Promise<StandardResponse<DiscordUserResponse>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<DiscordUserResponse>>
  > = get(`/api/discord/get-discord-user/${userId}`);
  return responseWithData.then(res => res.data);
}

export async function getDiscordRole({
  query,
  searchType,
  serverId
}: {
  query: string;
  searchType: 'id' | 'name';
  serverId?: string;
}): Promise<StandardResponse<{ role: DiscordRoleResponse; message?: string }>> {
  const params = new URLSearchParams({
    query,
    searchType
  });
  if (serverId) {
    params.append('serverId', serverId);
  }
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<{ role: DiscordRoleResponse }>>
  > = get(`/api/discord/role?${params.toString()}`);
  return responseWithData.then(res => res.data);
}
